<template>
    <v-dialog max-width="500px" v-model="showModal">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small>mdi-cancel</v-icon>
                
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span>{{ $page.props.lang.edit_membership ||'Izmeni članarinu'}}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="showModal = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-switch v-model="sub.is_limited" :label="$page.props.lang.limit_class_access || 'Ograniči aktivnosti'"></v-switch>
                        <label v-if="sub.is_limited" class="custom-label">{{$page.props.lang.select_activity_type || 'Izaberi dozvoljene aktivnosti'}}</label>
                        <div v-if="sub.is_limited">
                            <v-checkbox v-for="course in courses"
                                                v-bind:key="course.id"
                                                v-model="sub.courses"
                                                dense
                                                hide-details
                                                :label="course.title"
                                                :value="course.id"></v-checkbox>
                                    </div>
                                </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="submit" color="primary">Sačuvaj</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EventBus from '@/js/eventbus'

export default {
    props: {
        courses: Array,
        membership: Object
    },
    data(){
        return {
            showModal: false,
            sub: {
                id: this.membership.id,
                is_limited: this.membership.is_limited,
                courses: this.membership.courses.map((x) => x.id)
            }
        }
    },
    methods:{
        submit(){
            axios.post('/backoffice/members/membership/edit', this.sub)
                .then(response => {
                   
                  
               this.$inertia.reload();
                this.showModal = false;
                    
                })
                .catch(error => {
                    console.log(error)
                   
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: "Dogodila se greška",
                            color: 'error',
                            timeout: 10000
                        })
                })
        }
    }
}
</script>
